import React from 'react';
import PropTypes from 'prop-types';

const iterateChildren = (children) => {
  if (!Array.isArray(children)) return React.cloneElement(children);
  return children.map(
    (child, index) =>
      child && React.cloneElement(child, { key: `card-child-${index}` })
  );
};

const Card = ({ className, children, handleClick }) => {
  return (
    <div className={className} onClick={handleClick ? handleClick : null}>
      <div className="card" data-testid="card">
        {children && iterateChildren(children)}
      </div>
    </div>
  );
};

Card.defaultProps = {
  className: '',
  handleClick: null,
};

Card.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
};

const Header = ({ children }) => {
  if (!children) return;
  return (
    <div className="card__header">{children && iterateChildren(children)}</div>
  );
};

const Body = ({ children }) => {
  if (!children) return;
  return (
    <div className="card__body">{children && iterateChildren(children)}</div>
  );
};

const Footer = ({ children }) => {
  if (!children) return;
  return (
    <div className="card__footer">{children && iterateChildren(children)}</div>
  );
};

Card.Header = Header;
Card.Body = Body;
Card.Footer = Footer;

export default Card;
